import { PageType } from "shared/lib/page-type";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";

export const pathname = "/page";

export const page = {
  route(query: QueryParameters<{ appBarVariant?: AppBarVariant; entityId: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Page } };
  },
};
